import type {
  UserMessagePreviewChannel,
  UserMessagePreviewShortenedField,
  UserMessagePreviewTemplateId,
  UserMessagePreviewVariant,
} from '@aikoa/common'
import type { TFunction } from '@aikoa/i18n/react'

export function getMessagePreviewTemplateTitle(
  t: TFunction<'user'>,
  templateId: UserMessagePreviewTemplateId
) {
  switch (templateId) {
    case 'feedbackRequest':
      return t(($) => $.messagePreviews.template.feedbackRequest.title)
    case 'contactRequest':
      return t(($) => $.messagePreviews.template.contactRequest.title)
  }
}

export function getMessagePreviewTemplateDescription(
  t: TFunction<'user'>,
  templateId: UserMessagePreviewTemplateId
) {
  switch (templateId) {
    case 'feedbackRequest':
      return t(($) => $.messagePreviews.template.feedbackRequest.description)
    case 'contactRequest':
      return t(($) => $.messagePreviews.template.contactRequest.description)
  }
}

export function getMessagePreviewChannelLabel(
  t: TFunction<'user'>,
  channel: UserMessagePreviewChannel
) {
  switch (channel) {
    case 'email':
      return t(($) => $.messagePreviews.channel.email)
    case 'sms':
      return t(($) => $.messagePreviews.channel.sms)
  }
}

export function getMessagePreviewVariantLabel(
  t: TFunction<'user'>,
  variant: UserMessagePreviewVariant
) {
  switch (variant) {
    case 'default':
      return t(($) => $.messagePreviews.variant.default)
    case 'active':
      return t(($) => $.messagePreviews.variant.active)
    case 'preliminary':
      return t(($) => $.messagePreviews.variant.preliminary)
  }
}

export function getMessagePreviewShortenedFieldLabel(
  t: TFunction<'user'>,
  field: UserMessagePreviewShortenedField
) {
  switch (field) {
    case 'realtorName':
      return t(($) => $.messagePreviews.shortenedField.realtorName)
    case 'recipientName':
      return t(($) => $.messagePreviews.shortenedField.recipientName)
    case 'companyName':
      return t(($) => $.messagePreviews.shortenedField.companyName)
    case 'areaName':
      return t(($) => $.messagePreviews.shortenedField.areaName)
  }
}
